export const headerTopMenu = [
  // {
  //   id: 1,
  //   title: 'Мероприятия',
  //   link: '/events/',
  //   new_window: false,
  //   button: false,
  //   tel: false,
  //   email: false,
  //   class: ''
  // },
  {
    id: 2,
    title: 'Отзывы',
    link: 'https://fitron.club/reviews/',
    new_window: false,
    button: false,
    tel: false,
    email: false,
    class: ''
  },
  {
    id: 3,
    title: 'Контакты',
    link: 'https://fitron.club/contacts/',
    new_window: false,
    button: false,
    tel: false,
    email: false,
    class: ''
  },
];

export const headerBottomMenu = [
  /*
  {
    id: 2,
    title: 'Фитнес',
    link: '/fitness/',
    new_window: false,
    button: false,
    hide_mobile: false
  },
  */
  //   {
  //     id: 3,
  //     title: 'Питание',
  //     link: '/',
  //     new_window: false,
  //     button: false,
  //     hide_mobile: true
  //   },
  {
    id: 4,
    title: 'Расписание',
    link: 'https://fitron.club/fitness/raspisanie/?from=tariff',
    new_window: false,
    button: false,
    hide_mobile: false
  },
  {
    id: 5,
    title: 'Тарифы',
    link: '/',
    new_window: false,
    button: false,
    hide_mobile: false
  }
  /*
  {
    id: 6,
    title: 'Outdoor',
    link: '/fitness/outdoor/',
    new_window: false,
    button: false,
    hide_mobile: false
  },
  */
  // {
  //   id: 6,
  //   title: 'Фитнес-навигатор',
  //   link: 'https://free.fitron.club',
  //   new_window: true,
  //   button: false,
  //   hide_mobile: false
  // }
];

export const headerClubs = [
  {
    id: 1,
    title: 'FITRON Миллениум',
    link: 'https://fitron.club/clubs/millenium/',
    img: require('../../static/images/common/clubs/club-1.png')
  },
  {
    id: 2,
    title: 'FITRON Орбита',
    link: 'https://fitron.club/clubs/orbita/',
    img: require('../../static/images/common/clubs/club-2.png')
  },
  {
    id: 3,
    title: 'FITRON Горизонт',
    link: 'https://fitron.club/clubs/gorizont/',
    img: require('../../static/images/common/clubs/club-3.png')
  },
  {
    id: 4,
    title: 'FITRON Газетный',
    link: 'https://fitron.club/clubs/gazetny/',
    img: require('../../static/images/common/clubs/club-4.png')
  }
];
